import { ServiceTypeResidualPercentUpsertDialogStore } from './service-type-residual-percent-upsert-dialog.store';
import { fb } from '../../../../../modules/shared/shared.global-service';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent } from '../../../../kit/base-dialog/base-dialog.component';
import { Validators } from '@angular/forms';
import { dateify } from '../../../../../modules/shared/helpers/date.helper';
import { isInvalid } from '../../../../../modules/shared/helpers/validate';
import { contentGlobalSuccess } from '../../../../../modules/content/content.error';
import {
    SocialServiceResidualPercentPatchInput,
} from '@libs/types/src/services/input-type/services/social-service/social-service-residual-percent.patch-input';
import {
    SocialServiceResidualPercentCreateInput,
} from '@libs/types/src/services/input-type/services/social-service/social-service-residual-percent.create-input';
import { DateInputComponent } from '../../../../kit/input/date-input/date-input.component';
import { NumberInputComponent } from '../../../../kit/input/text-input/number-input.component';

@Component({
    selector: 'app-service-type-residual-percent-upsert-dialog',
    templateUrl: './service-type-residual-percent-upsert-dialog.component.html',
    styleUrl: './service-type-residual-percent-upsert-dialog.component.scss',
    providers: [ServiceTypeResidualPercentUpsertDialogStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        DateInputComponent,
        NumberInputComponent,
    ],
})
export class ServiceTypeResidualPercentUpsertDialogComponent extends BaseDialogComponent {

    public readonly store = inject(ServiceTypeResidualPercentUpsertDialogStore);

    protected prefix = 'serviceType.residualPercent.';

    protected form = fb.group({
        percent: fb.control<number | null>(null, Validators.required),
        validFrom: fb.control<Date | null>(null),
        validTo: fb.control<Date | null>(null),
    });

    constructor() {
        super();
        const residualPercent = this.dialogConfig.data.residualPercent;
        if (residualPercent) {
            this.form.patchValue({
                ...residualPercent,
                validFrom: dateify(residualPercent.validFrom),
                validTo: dateify(residualPercent.validTo),
            });
        }
    }

    public override async save(): Promise<void> {
        if (isInvalid(this.form)) return;

        const id = this.dialogConfig.data.residualPercent?.id;
        const data = {
            ...this.form.getRawValue(),
        };

        if (id) {
            const input = data as SocialServiceResidualPercentPatchInput;
            input.id = id;
            await this.store.api.patchSocialServiceResidualPercent(input, 'id');
            contentGlobalSuccess.next('common.updated');
        } else {
            const input = data as SocialServiceResidualPercentCreateInput;
            input.serviceTypeId = this.store.serviceType().id;
            await this.store.api.createSocialServiceResidualPercent(input, 'id');
            contentGlobalSuccess.next('common.created');
        }

        this.dialogRef.close(true);
    }

}
